import React from 'react'
import _ from 'lodash'
import { Popup, Button, Grid } from 'semantic-ui-react'

const VendorInfoButton = ({ vendorData, onClick }) => {
  return (
    <Popup
      wide
      on="hover"
      trigger={
        <Button
          icon
          size="mini"
          color="black"
          onClick={onClick}
          content={vendorData.official_info ? 'Show/Edit Info' : 'Add Info'}
        />
      }
    >
      {vendorData.official_info ? (
        <Grid centered columns={2} style={{ width: 400 }}>
          <Grid.Row style={{ paddingBottom: 0 }}>
            <Grid.Column>
              <p>Company Name (EN):</p>
              <p>Company Name (KH):</p>
            </Grid.Column>
            <Grid.Column>
              <p>{_.get(vendorData, 'official_info.name.en', 'N/A')}</p>
              <p>{_.get(vendorData, 'official_info.name.kh', 'N/A')}</p>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row style={{ paddingBottom: 0 }}>
            <Grid.Column>
              <p>Address (EN):</p>
            </Grid.Column>
            <Grid.Column>
              <p>{_.get(vendorData, 'official_info.address.en', 'N/A')}</p>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row style={{ paddingBottom: 0 }}>
            <Grid.Column>
              <p>Address (KH):</p>
            </Grid.Column>
            <Grid.Column>
              <p>{_.get(vendorData, 'official_info.address.kh', 'N/A')}</p>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <p>Phone:</p>
              <p>VATTIN:</p>
            </Grid.Column>
            <Grid.Column>
              <p>{_.get(vendorData, 'official_info.phone', 'N/A')}</p>
              <p>{_.get(vendorData, 'official_info.vattin', 'N/A')}</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      ) : (
        <div>There is no data</div>
      )}
    </Popup>
  )
}

export default VendorInfoButton



// WEBPACK FOOTER //
// ./src/components/restaurants/views/vendorInfoButton.js